module.exports = __webpack_public_path__ + "img/2366.ef8ed7f1.gif";